<template>
  <div>
    <div class="container">
      <div class="searchbox">
        <div class="item">
          <span>药品名称</span>
          <el-input
            placeholder="请输入"
            v-model="goods_name"
            style="width: 130px; margin-left: 8px"
            @input="search"
            clearable
          ></el-input>
        </div>
        <div class="item">
          <span>药品剂型</span>
          <el-select
            v-model="dosage_form"
            placeholder="请选择"
            style="width: 130px; margin-left: 8px"
            @change="search"
            clearable
          >
            <el-option
              v-for="item in dosage_form_list"
              :key="item.drug_type"
              :label="item.drug_type_name"
              :value="item.drug_type"
            ></el-option>
          </el-select>
        </div>
        <div class="item">
          <span>用药时间</span>
          <el-date-picker
            v-model="date"
            type="daterange"
            range-separator="~"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            style="width: 225px; margin-left: 8px"
            @change="search"
            clearable
          ></el-date-picker>
        </div>

        <div class="item">
          <span>关联单号</span>
          <el-input
            placeholder="请输入"
            v-model="order_sn"
            style="width: 130px; margin-left: 8px"
            @input="search"
            clearable
          ></el-input>
        </div>

        <div class="item flex align-center">
          <span style="margin-right: 12px">是否校正</span>
          <el-radio-group v-model="correct_bool" @change="search">
            <el-radio :label="''">全部</el-radio>
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div style="margin: 12px 0 16px 0" class="flex between">
        <div>
          <el-button type="primary" @click="search" size="medium"
            >查询</el-button
          >
          <el-button plain @click="clearSearch" size="medium">重置</el-button>
        </div>
        <div>
          <el-button
            type="primary"
            @click="outData"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('485') : false
            "
            size="medium"
            >导出Excel</el-button
          >
        </div>
      </div>
      <div style="border: solid 1px #c9cbd6">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%; min-width: 1000px"
          :header-cell-style="{ background: '#F5F5F5' }"
          @sort-change="changeOrder"
          v-loading="loading"
          element-loading-text="拼命加载中"
          element-loading-background="rgba(0, 0, 0,0.1)"
        >
          <el-table-column prop="goods_name" label="药品名称"></el-table-column>
          <el-table-column
            prop="drug_type_name"
            label="药品剂型"
          ></el-table-column>
          <el-table-column
            prop="item_use_level"
            label="销售量"
            sortable="custom"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.item_use_level"
                >{{ scope.row.item_use_level }}g</span
              >
            </template>
          </el-table-column>
          <el-table-column prop="correct_num" label="校正量" sortable="custom">
            <template slot-scope="scope">
              <span v-if="scope.row.correct_num"
                >{{ scope.row.correct_num }}g</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="correct_count"
            label="校正次数"
          ></el-table-column>

          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="toCorrect(scope.row)"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('493') : false
                "
                >校正编辑</el-button
              >
              <el-button
                type="text"
                @click="toDetails(scope.row)"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('481') : false
                "
              >
                详情
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div style="margin-top: 20px">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      drug_code: "",
      goods_name: "",
      dosage_form: "",
      order_sn: "",
      correct_bool: "",
      hospital_id: "",
      date: [],
      dosage_form_list: [],
      hospitalList: [],
      loading: true,
      orderby: 0,
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  created() {
    this.initDate();
    this.getDosageList();
    this.getHospitalList();
  },
  activated() {
    this.initDate();
    this.getList();
  },
  methods: {
    initDate() {
      let end = new Date();
      let start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      end = dayjs(end).format("YYYY-MM-DD");
      start = dayjs(start).format("YYYY-MM-DD");
      this.date = [start, end];
    },
    //获取药品列表
    getList() {
      this.loading = true;
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        drug_code: this.drug_code,
        goods_name: this.goods_name,
        dosage_form: this.dosage_form,
        order_sn: this.order_sn,
        correct_bool: this.correct_bool,
        orderby: this.orderby,
      };
      if (this.date && this.date.length > 0) {
        data.create_time_start = dayjs(this.date[0]).format("YYYY-MM-DD");
        data.create_time_end = dayjs(this.date[1]).format("YYYY-MM-DD");
      }
      this.axios
        .post("platform/hospital/getGoodsCorrect", data)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list;
            this.totalNum = res.data.total;
            this.loading = false;
          } else {
            this.loading = false;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    //更改顺序
    changeOrder(value) {
      let order = value.order;
      let prop = value.prop;

      //升序
      if (order == "ascending") {
        if (prop == "item_use_level") {
          this.orderby = 1;
        } else if (prop == "correct_num") {
          this.orderby = 3;
        }
      }
      //降序
      if (order == "descending") {
        if (prop == "item_use_level") {
          this.orderby = 2;
        } else if (prop == "correct_num") {
          this.orderby = 4;
        }
      }
      if (!order) {
        this.orderby = 0;
      }
      this.getList();
    },
    //导出
    outData() {
      let loading = this.$loading();
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        drug_code: this.drug_code,
        goods_name: this.goods_name,
        dosage_form: this.dosage_form,
        order_sn: this.order_sn,
        correct_bool: this.correct_bool,
        orderby: this.orderby,
      };
      if (this.date && this.date.length > 0) {
        data.create_time_start = dayjs(this.date[0]).format("YYYY-MM-DD");
        data.create_time_end = dayjs(this.date[1]).format("YYYY-MM-DD");
      }
      this.axios
        .post("platform/hospital/exporCorrect", data)
        .then((res) => {
          if (res.code == 0) {
            let host =
              document.location.protocol +
              "//" +
              window.location.host +
              res.data.url +
              "?correct_no=" +
              res.data.correct_no;
            location.href = host;
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
    //校正编辑
    toCorrect(row) {
      let { goods_id, drug_id, dosage_form, drug_type } = row;
      this.$router.push({
        path: "/home/hospital/statisticsDetails",
        query: {
          goods_id,
          drug_id,
          dosage_form,
          type: 2,
          drug_type,
        },
      });
    },
    // 详情
    toDetails(row) {
      let { goods_id, drug_id, dosage_form, drug_type } = row;
      this.$router.push({
        path: "/home/hospital/statisticsDetails",
        query: {
          goods_id,
          drug_id,
          dosage_form,
          type: 2,
          activeName: 2,
          drug_type,
        },
      });
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //清空搜索框
    clearSearch() {
      this.drug_code = "";
      this.goods_name = "";
      this.dosage_form = "";
      this.date = [];
      this.order_sn = "";
      this.correct_bool = "";
      this.getList();
    },
    //每页数据
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //翻页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    getDosageList() {
      let platform_type = 3;
      this.axios
        .post("platform/photograph/getDrugTypeList", { platform_type })
        .then((res) => {
          this.dosage_form_list = res.data.list;
        });
    },
    //药房列表
    getHospitalList() {
      let data = {
        org_type: 0,
        hospiatl_type: 0,
        page: 1,
        pageNumber: 10000,
      };
      this.axios.post("platform/hospital/getHospitaList", data).then((res) => {
        this.hospitalList = res.data.list.map((item) => {
          return {
            hospital_id: item.hospital_id,
            hospital_name: item.hospital_name,
          };
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  padding: 0 20px 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.mydivider {
  margin: 0;
}
.dialogtable {
  width: 530px;
  margin: 0 auto 20px;
  background-color: #ffffff;
  box-sizing: border-box;
  border: solid 1px #c9cbd6;
}
.btnbox {
  text-align: left;
  margin: 20px 0;
  padding-left: 14px;
}
.searchbox {
  display: flex;
  flex-wrap: wrap;
  .item {
    margin-right: 30px;
    margin-top: 16px;
  }
}
</style>
